import NProgress from "nprogress";

export { onPageTransitionStart };

async function onPageTransitionStart() {
  NProgress.start();
}